if (!customElements.get('header-navigation')) {
  customElements.define(
    'header-navigation',
    class HeaderNavigation extends HTMLElement {
      constructor() {
        super();

        this.popupLinks?.forEach((popupLink) => {
          /**
           * @type {HTMLElement | null}
           */
          const container = popupLink.closest('.header-navigation__item');

          popupLink.addEventListener('focus', () => this.setAriaExpanded(popupLink));
          popupLink.addEventListener('blur', () => this.removeAriaExpanded(popupLink));

          if (!container) return;

          container.addEventListener('mouseenter', () => this.setAriaExpanded(popupLink));
          container.addEventListener('mouseleave', () => this.removeAriaExpanded(popupLink));
        });
      }

      /**
       * @param {HTMLLinkElement} link
       */
      setAriaExpanded(link) {
        link.setAttribute('aria-expanded', 'true');
      }

      /**
       * @param {HTMLLinkElement} link
       */
      removeAriaExpanded(link) {
        link.setAttribute('aria-expanded', 'false');
      }

      /**
       * @type {NodeListOf<HTMLLinkElement> | null}
       */
      get popupLinks() {
        return this.querySelectorAll('.header-navigation__link[aria-haspopup="true"]');
      }
    },
  );
}
